export default {
    DATE_FORMAT: "DD.MM.YYYY",
    DATETIME_FORMAT: "DD.MM.YYYY HH:mm",
    DATETIME_WITH_SECONDS_FORMAT: "YYYY.MM.DD HH:mm:ss"
}
